import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';
import { AppIcon } from '@backrs_ui/common-ui/src/designSystem/icons/AppIcon';
import { Box, Chip, Typography, Tooltip, ClickAwayListener } from '@mui/material';
var ROI_LINE_CHART_STRINGS = appStrings.modules.charts.returnOnInvestment;
var getChipIcon = function (_a) {
    var total_roi = _a.total_roi, average_roi = _a.average_roi;
    if (total_roi > average_roi) {
        return (_jsx(AppIcon, { iconName: "ThumbsUp", diameter: "12px", color: "Colors/Foreground/fg-success-secondary" }));
    }
    if (total_roi < average_roi) {
        return (_jsx(AppIcon, { iconName: "ThumbsDown", diameter: "12px", color: "Colors/Foreground/fg-error-secondary" }));
    }
    return _jsx(AppIcon, { iconName: "Equal", diameter: "12px", color: "Colors/Foreground/fg-quinary" });
};
export var ROILineChartHeader = function (_a) {
    var total_roi = _a.total_roi, average_roi = _a.average_roi;
    var _b = useState(false), isMuiTooltipOpen = _b[0], setIsMuiTooltipOpen = _b[1];
    return (_jsxs(Box, { sx: titleContentSx, children: [_jsxs(Box, { sx: titleSx, children: [_jsx(Typography, { variant: "text-lg-semibold", component: "div", children: ROI_LINE_CHART_STRINGS.title }), _jsx(ClickAwayListener, { onClickAway: function () { return setIsMuiTooltipOpen(false); }, children: _jsx(Tooltip, { open: isMuiTooltipOpen, onClose: function () { return setIsMuiTooltipOpen(false); }, placement: "top", arrow: true, disableFocusListener: true, disableHoverListener: true, disableTouchListener: true, sx: tooltipSx, componentsProps: {
                                tooltip: {
                                    sx: toolTipComponentSx,
                                },
                            }, title: ROI_LINE_CHART_STRINGS.tooltip, children: _jsx(Box, { sx: tooltipIconSx, onClick: function () { return setIsMuiTooltipOpen(function (prev) { return !prev; }); }, children: _jsx(AppIcon, { iconName: "InfoCircle", diameter: "20px", color: "Colors/Foreground/fg-quinary" }) }) }) })] }), _jsxs(Box, { sx: totalInvestmentSx, children: [_jsxs(Typography, { variant: "display-sm-semibold", component: "div", children: [total_roi, "%"] }), _jsx(Chip, { variant: "badge", size: "md", type: "leading", label: ROI_LINE_CHART_STRINGS.chipLabel(total_roi, average_roi), icon: getChipIcon({ total_roi: total_roi, average_roi: average_roi }) })] })] }));
};
var titleContentSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: 'column',
        gap: backrs.spacing['spacing-md'],
    });
};
var totalInvestmentSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: backrs.spacing['spacing-lg'],
        mb: { xs: backrs.spacing['spacing-2xl'], sm: backrs.spacing['spacing-none'] },
    });
};
var titleSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        alignItems: { xs: 'flex-start', sm: 'center' },
        flexDirection: { xs: 'row', sm: 'row' },
        justifyContent: 'space-between',
        gap: backrs.spacing['spacing-sm'],
    });
};
var tooltipIconSx = {
    cursor: 'pointer',
};
var tooltipSx = {
    fontFamily: 'Sarabun, sans-serif',
    whiteSpace: 'pre-line',
    '& .MuiTooltip-tooltip': {
        fontFamily: 'Sarabun, sans-serif',
        whiteSpace: 'pre-line',
    },
};
var toolTipComponentSx = {
    fontFamily: 'Sarabun, sans-serif',
    whiteSpace: 'pre-line',
};
